/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFacialRecognition = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h6v2H4v5H2zm14 0h6v7h-2V4h-4zm-6 8H8V8h2zm6 0h-2V8h2zm-3.271 4.942c1.106-.207 2.007-.934 2.482-1.544l1.578 1.228c-.692.89-1.99 1.963-3.693 2.282-1.775.332-3.805-.19-5.803-2.189l1.414-1.414c1.602 1.602 2.988 1.83 4.022 1.637zM2 15h2v5h4v2H2zm18 5v-5h2v7h-6v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFacialRecognition as FacialRecognition };
